import { render, staticRenderFns } from "./NotionalAccountCard.vue?vue&type=template&id=c22bc3e0&scoped=true"
import script from "./NotionalAccountCard.vue?vue&type=script&lang=ts"
export * from "./NotionalAccountCard.vue?vue&type=script&lang=ts"
import style0 from "./NotionalAccountCard.vue?vue&type=style&index=0&id=c22bc3e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22bc3e0",
  null
  
)

export default component.exports